import { render, staticRenderFns } from "./SFKnob.vue?vue&type=template&id=84cde4e2&lang=pug&"
import script from "./SFKnob.vue?vue&type=script&lang=ts&"
export * from "./SFKnob.vue?vue&type=script&lang=ts&"
import style0 from "./SFKnob.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports